import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { EntityBackButton } from "@modules/components/buttons/EntityBackButton/EntityBackButton";

import "./MobileExitButton.css";
import { useMemo } from "react";
import { useMatch, useSearchParams } from "react-router";

const MobileExitButton = () => {
  const { isMobile } = useWindowSize();
  const isPlanScreen = useMatch("/plan");
  const [searchParams] = useSearchParams();
  const isMobileMapView = searchParams.get("view") === "map";

  const shouldShow = useMemo(() => {
    if (!isPlanScreen && !isMobileMapView) {
      return false;
    }

    return true;
  }, [isMobileMapView, isPlanScreen]);

  if (!isMobile || !shouldShow) {
    return null;
  }

  return (
    <div className="mobile-exit-button-component">
      <EntityBackButton variant="close" />
    </div>
  );
};

export { MobileExitButton };
